module.exports = "<p>\r\n  file-upload works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/file-upload/file-upload.component.html
// module id = 0P26
// module chunks = 2